import overrideIfMinBetNumberEnabled from "./MinBetNumberRegistrator";
/*tslint:disable:cyclomatic-complexity*/
overrideIfMinBetNumberEnabled(function () {
    (function (ukSPSlipMode) {
        if (!ukSPSlipMode) {
            return;
        }
        var _buildHeader = ukSPSlipMode.prototype.buildHeader;
        $.extend(ukSPSlipMode.prototype, {
            buildHeader() {
                //we render betslip synchronously and in next order header => selections so header state is not based on latest validation
                //this call will trigger 'validateMinBetNumber' for all possible combinations
                //so we will get actual validation result on header render step
                BetSlip.CurrentMode.updateViewOptions();
                return _buildHeader.call(this);
            },
            getHeaderText() {
                return this.isBetslipValid() ? $dict.bs("ScrollDownToPlaceBet") : $dict.bs("NeedMoreSelections");
            },
            getHeaderStylesString() {
                var isValidSelections = this.isBetslipValid(), styles = [
                    "betSlip-message",
                    "betSlip-message-min-bet-number",
                    isValidSelections ? "betSlip-message-success" : "betSlip-message-danger"
                ];
                return styles.join(" ");
            },
            areComboDoublesValidFlag: false,
            getIncludedSelections() {
                return Array.getValues(this.getSelections()).filter(function (x) { return !this.ExcludedSelections[x.ViewKey]; }.bind(this));
            },
            areAllSinglesValid() {
                //for 'Singles' doesnt matter if checkboxes are checked so 'BetSlip.Selections'
                var selections = Array.getValues(BetSlip.Selections).filter(function (sel) {
                    //we skip multiline selections cuz they dont contain any MBN info and used only as a reducer
                    return !sel.IsMultiLine;
                });
                return selections.length && selections.all(function (x) { return x.MinBetNumber === 1; });
            },
            isBetslipValid() {
                var selections = this.getIncludedSelections();
                return selections.any(function (x) { return x.MinBetNumber === 1; }) // at least selection has 1 mbn -> joker case
                    || (selections.length > 1 && this.areComboDoublesValidFlag) // doubles are good
                    || this.areAllSinglesValid() // nothing is checked but all selections have 1 mbn
                    || selections.length > 2; //Trebles, 4folds, .. => should be good
            },
            toShowStakeBox(selection) {
                return selection && (selection.MinBetNumber === 1 || selection.IsMultiLine);
            },
            validateMinBetNumberForDoubles(selections) {
                var allMBNs = selections.map(function (x) { return x.MinBetNumber; }).sort().reverse();
                for (var i = 0; i < allMBNs.length - 1; i++) {
                    var sum = allMBNs[i] + allMBNs[i + 1];
                    //2 3
                    //3 3
                    if (sum === 5 || sum === 6) {
                        return false;
                    }
                }
                return true;
            },
            validateMinBetNumber(selections, options) {
                selections = selections || this.getIncludedSelections();
                selections = selections.filter(function (x) { return !this.ExcludedSelections[x.ViewKey]; }.bind(this));
                if (!selections.length) {
                    return false;
                }
                //validation for stake box => only for valid singles
                if (selections.length === 1 && selections[0].MinBetNumber !== 1) {
                    //2
                    //3
                    return false;
                }
                var result = true, betKey = options && options.key * 1;
                if (!betKey) {
                    return result;
                }
                //for system => check all prev combos
                if (options.ukSubMode === UKSlipModeSubModes.System) {
                    //for system with singles => +validation for singles => all singles should be valid as single bet
                    result = this.areComboDoublesValidFlag && (this.isSystemWithSingleBets(betKey) ? this.areAllSinglesValid() : true);
                }
                //for combos doubles
                if (options.ukSubMode === UKSlipModeSubModes.Combo && betKey === 2) {
                    result = this.validateMinBetNumberForDoubles(selections);
                    this.areComboDoublesValidFlag = result;
                }
                return result;
            }
        });
    })(window.UKSPSlipMode);
});
//# sourceMappingURL=UKSPSlipMode.js.map